<template>
  <div>
    <h2>Redireccionando al video...</h2>
    <p>Si no eres redirigido, <a :href="youtubeUrl">haz clic aquí</a>.</p>
  </div>
</template>

<script>
export default {
  name: 'RedirectToYouTube',
  data() {
    return {
      // Puedes cambiar esta URL por el video de YouTube que prefieras
      youtubeUrl: 'https://youtu.be/_B5YdHExasM&fs=1'
    };
  },
  mounted() {
    // Esta línea realiza la redirección
    window.location.href = this.youtubeUrl;
  }
};
</script>

<style scoped>
div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-family: sans-serif;
}
</style>